module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('form', {
    staticClass: "m_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "id": "login-form",
      "name": "pop-form-login",
      "method": "post",
      "action": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "appkey",
      "value": ""
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "登录帐号",
      "hintText": "请输入登录手机号码",
      "labelFloat": ""
    }
  }), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "登录密码",
      "hintText": "请输入密码",
      "type": "password",
      "labelFloat": ""
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "geetest"
  }, [_c('div', {
    staticClass: "gt_bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "mr_b15"
  }, [_c('mu-raised-button', {
    staticClass: "submit-btn demo-raised-button",
    attrs: {
      "label": "登录",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.gotoLogin(_vm.open)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mr_b15"
  }, [_c('mu-raised-button', {
    staticClass: "reg-btn demo-raised-button",
    attrs: {
      "label": "注册",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.toRegister()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "width90"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cross_post",
      "value": "1"
    }
  })])], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "小提示"
    },
    on: {
      "close": _vm.close
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.openCon) + "\n\t\t\t"), _c('mu-flat-button', {
    attrs: {
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m_header"
  }, [_c('a', {
    staticClass: "goback",
    attrs: {
      "href": "#/app/newSong"
    }
  }, [_vm._v("返回")]), _vm._v("\n\t\t\t账号登录\n\t\t\t"), _c('a', {
    staticClass: "m_header_refresh J_refresh",
    attrs: {
      "href": "javascript:;"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "m_label"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/logo.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c81516c4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xlogin.vue
// module id = 276
// module chunks = 0